module.exports = __webpack_public_path__ + "img/banner.464f6c75.png";